import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class VersionService {
  getCurrentVersion(): string {
    return environment.appVersion;
  }

  compareSemver(a: string, b: string): -1 | 0 | 1 {
    const normalize = (v: string) => v.replace(/^v/, '');
    const partsA = normalize(a).split('.').map(Number);
    const partsB = normalize(b).split('.').map(Number);
    const len = Math.max(partsA.length, partsB.length);

    for (let i = 0; i < len; i++) {
      const numA = partsA[i] ?? 0;
      const numB = partsB[i] ?? 0;
      if (numA < numB) return -1;
      if (numA > numB) return 1;
    }
    return 0;
  }

  isUpdateMandatory(current: string, minimum: string): boolean {
    return this.compareSemver(current, minimum) < 0;
  }

  isUpdateOptional(current: string, latest: string): boolean {
    return this.compareSemver(current, latest) < 0;
  }
}
